import { render, staticRenderFns } from "./ManagePage.vue?vue&type=template&id=62bd9820&scoped=true"
import script from "./ManagePage.vue?vue&type=script&lang=js"
export * from "./ManagePage.vue?vue&type=script&lang=js"
import style0 from "./ManagePage.vue?vue&type=style&index=0&id=62bd9820&prod&lang=scss&scoped=true"
import style1 from "./ManagePage.vue?vue&type=style&index=1&id=62bd9820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd9820",
  null
  
)

export default component.exports